<template>
  <!-- <div class="container"> -->
    <slot />
  <!-- </div> -->
</template>

<script>

export default {
  name: "Authorization",
  components: {
  }
}
</script>